<div class="search-wrapper">
  <div class="media-search-filter" *ngIf="searchMode === 'video'">
    <div class="sort-by-wrapper">
      <div class="title-wrapper">
        <span>Sort By</span>
        <i (click)="onOrderByClick()">
          <svg
            [ngClass]="{ 'descending-sort-media': !ascendingOrderMedia }"
            width="20px"
            height="8px"
          >
            <path
              fill-rule="evenodd"
              fill="rgb(64, 196, 255)"
              d="M9.998,7.999 L9.998,6.999 L19.999,6.999 L19.999,7.999 L9.998,7.999 ZM9.998,4.999 L17.999,4.999 L17.999,5.999 L9.998,5.999 L9.998,4.999 ZM9.998,2.999 L16.998,2.999 L16.998,3.999 L9.998,3.999 L9.998,2.999 ZM9.998,0.999 L14.999,0.999 L14.999,1.999 L9.998,1.999 L9.998,0.999 ZM6.300,4.241 L3.954,1.878 L3.954,7.999 L2.962,7.999 L2.962,1.948 L0.687,4.241 L-0.015,3.534 L2.791,0.706 L2.791,0.706 L3.493,-0.001 L4.194,0.706 L4.194,0.706 L7.000,3.534 L6.300,4.241 Z"
            />
          </svg>
        </i>
      </div>

      <div class="icn-radio-button">
        <input
          type="radio"
          id="l"
          name="radiogroup5"
          [checked]="isSortOptionChecked('Name')"
        />
        <label for="l" (click)="onClickSortByOption($event, 'Name')">Name</label
        ><br />
        <div class="radio-separator"></div>
        <input
          type="radio"
          id="m"
          name="radiogroup5"
          [checked]="isSortOptionChecked('Type')"
        />
        <label for="m" (click)="onClickSortByOption($event, 'Type')">Type</label
        ><br />
        <div class="radio-separator"></div>
        <input
          type="radio"
          id="n"
          name="radiogroup5"
          [checked]="isSortOptionChecked('Duration')"
        />
        <label for="n" (click)="onClickSortByOption($event, 'Duration')"
          >Duration</label
        ><br />
        <div class="radio-separator"></div>
        <input
          type="radio"
          id="o"
          name="radiogroup5"
          [checked]="isSortOptionChecked('DateCreated')"
        />
        <label for="o" (click)="onClickSortByOption($event, 'DateCreated')"
          >Creation Date</label
        ><br />
      </div>
    </div>

    <div class="filter-by-wrapper">
      <div class="title-wrapper">
        <span>Filter By</span>
        <span class="clear-all-filters" (click)="onClearAllFilters()"
          >Clear All</span
        >
      </div>

      <div class="filter-by-options">
        <div class="status-container">
          <label class="filter-option-header">STATUS:</label>
          <div class="icn-radio-button icn-radio-button2">
            <input
              type="radio"
              id="p"
              name="radiogroup6"
              [checked]="isStatusChosen('All')"
            />
            <label for="p" (click)="onClickStatusByOption($event, 'All')"
              >All</label
            ><br />
            <div class="radio-separator"></div>
            <input
              type="radio"
              id="q"
              name="radiogroup6"
              [checked]="isStatusChosen('Ready')"
            />
            <label for="q" (click)="onClickStatusByOption($event, 'Ready')"
              >Ready</label
            ><br />
            <div class="radio-separator"></div>
            <input
              type="radio"
              id="r"
              name="radiogroup6"
              [checked]="isStatusChosen('Uploading')"
            />
            <label for="r" (click)="onClickStatusByOption($event, 'Uploading')"
              >Uploading</label
            ><br />
          </div>
        </div>

        <div class="tag-container">
          <label class="filter-option-header">TAGS:</label>
          <ul class="tag-list-container">
            <li>
              <input
                type="checkbox"
                id="allTags"
                class="input-hidden"
                (click)="onClickAllTags($event)"
                [checked]="checkAllTags"
              />
              <label for="allTags">Any Tags</label>
            </li>

            <li
              *ngFor="let tag of tags; let index = index"
              [ngClass]="{ 'display-none': index >= 5 && !showMoreTags }"
            >
              <ng-container *ngIf="index < 5 || showMoreTags">
                <input
                  type="checkbox"
                  [id]="index + 'tag'"
                  class="input-hidden"
                  (click)="onClickTag($event, index)"
                  [checked]="isChecked(index)"
                />
                <label [for]="index + 'tag'">{{ tag.name }}</label>
              </ng-container>
            </li>
            <li *ngIf="!showMoreTags" class="more-tags">
              <input
                type="checkbox"
                id="moreTags"
                class="input-hidden"
                (click)="onToggleTags($event, true)"
              />
              <label for="moreTags"></label>
            </li>
            <li *ngIf="showMoreTags" class="less-tags">
              <input
                type="checkbox"
                id="lessTags"
                class="input-hidden"
                (click)="onToggleTags($event, false)"
              />
              <label for="lessTags"></label>
            </li>
          </ul>
        </div>

        <!-- <div class="asset-type-container">
                    <label class="filter-option-header">ASSET TYPE:</label>
                    <ul class="asset-type-list-container">

                        <li>
                            <input type="checkbox" id="allAssets" class="input-hidden" (click)="onClickAllAssets($event)" [checked]="checkAllAssets"/>
                            <label for="allAssets">All Asset Types</label>
                        </li>


                        <li *ngFor="let assetType of assetTypes; let index = index" [ngClass]="{'display-none': index >= 5 && !showMoreAssets}">

                            <ng-container *ngIf="index < 5 || showMoreAssets">
                                <input type="checkbox" [id]="index + 'assetType'" class="input-hidden" (click)="onClickAssetType($event, index)" [checked]="isAssetChecked(index)"/>
                                <label [for]="index + 'assetType'">{{assetType.name}}</label>
                            </ng-container>
                        </li>
                        <li *ngIf="!showMoreAssets" class="more-tags">
                            <input type="checkbox" id="moreAssetType" class="input-hidden" (click)="onToggleAssetType($event, true)"/>
                            <label for="moreAssetType"></label>
                        </li>
                        <li *ngIf="showMoreAssets"  class="less-tags">
                            <input type="checkbox" id="lessAssetType" class="input-hidden" (click)="onToggleAssetType($event, false)"/>
                            <label for="lessAssetType"></label>
                        </li>
                    </ul>
                </div> -->

        <div
          class="languages-container"
          *ngIf="languages && languages.length > 0"
        >
          <label class="filter-option-header">LANGUAGE:</label>
          <ul class="languages-list-container">
            <li>
              <input
                type="checkbox"
                id="allLanguages"
                class="input-hidden"
                (click)="onClickAllLanguages($event)"
                [checked]="checkAllLanguages"
              />
              <label for="allLanguages">Any Languages</label>
            </li>

            <li
              *ngFor="let lang of languages; let index = index"
              [ngClass]="{ 'display-none': index >= 5 && !showMoreLanguages }"
            >
              <ng-container *ngIf="index < 5 || showMoreLanguages">
                <input
                  type="checkbox"
                  [id]="index + 'lang'"
                  class="input-hidden"
                  (click)="onClickLanguage($event, index)"
                  [checked]="isLanguageChecked(index)"
                />
                <label [for]="index + 'lang'">{{
                  lang.code.toUpperCase()
                }}</label>
              </ng-container>
            </li>
            <li *ngIf="!showMoreLanguages" class="more-tags">
              <input
                type="checkbox"
                id="moreLanguages"
                class="input-hidden"
                (click)="onToggleLanguages($event, true)"
              />
              <label for="moreLanguages"></label>
            </li>
            <li *ngIf="showMoreLanguages" class="less-tags">
              <input
                type="checkbox"
                id="lessLanguages"
                class="input-hidden"
                (click)="onToggleLanguages($event, false)"
              />
              <label for="lessLanguages"></label>
            </li>
          </ul>
        </div>

        <div class="date-created-container">
          <label class="filter-option-header">DATE CREATED:</label>
          <div>
            <label for="date-created-from">From:</label>
            <dateinput
              id="date-created-from"
              [(current)]="startDateCreatedMedia"
              (currentChange)="changeStartDateCreated($event)"
            ></dateinput>
          </div>

          <div>
            <label for="date-created-to">To:</label>
            <dateinput
              id="date-created-to"
              [(current)]="endDateCreatedMedia"
              (currentChange)="changeEndDateCreated($event)"
            ></dateinput>
          </div>
        </div>

        <div class="license-container">
          <label class="filter-option-header">LICENSE:</label>
          <div>
            <label for="license-filter-from">From:</label>
            <dateinput
              id="license-filter-from"
              [(current)]="startDateLicense"
              (currentChange)="changeStartDateLicense($event)"
            ></dateinput>
          </div>
          <div>
            <label for="license-filter-to">To:</label>
            <dateinput
              id="license-filter-to"
              [(current)]="endDateLicense"
              (currentChange)="changeEndDateLicense($event)"
            ></dateinput>
          </div>

          <div class="countries-container">
            <ul class="countries-list-container">
              <li>
                <input
                  type="checkbox"
                  id="allCountries"
                  class="input-hidden"
                  (click)="onClickAllCountries($event)"
                  [checked]="checkAllCountries"
                />
                <label for="allCountries">All Countries</label>
              </li>

              <li
                *ngFor="let country of countries; let index = index"
                [ngClass]="{ 'display-none': index >= 5 && !showMoreCountries }"
              >
                <ng-container *ngIf="index < 5 || showMoreCountries">
                  <input
                    type="checkbox"
                    [id]="index + 'country'"
                    class="input-hidden"
                    (click)="onClickCountry($event, index)"
                    [checked]="isCountryChecked(index)"
                  />
                  <label [for]="index + 'country'">{{ country.name }}</label>
                </ng-container>
              </li>
              <li *ngIf="!showMoreCountries" class="more-tags">
                <input
                  type="checkbox"
                  id="moreCountries"
                  class="input-hidden"
                  (click)="onToggleCountries($event, true)"
                />
                <label for="moreCountries"></label>
              </li>
              <li *ngIf="showMoreCountries" class="less-tags">
                <input
                  type="checkbox"
                  id="lessCountries"
                  class="input-hidden"
                  (click)="onToggleCountries($event, false)"
                />
                <label for="lessCountries"></label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="graphics-search-filter" *ngIf="searchMode === 'graphics'">
    <div class="sort-by-wrapper">
      <div class="title-wrapper">
        <span>Sort By</span>
        <i (click)="onOrderByClick()">
          <svg
            [ngClass]="{ 'descending-sort-graphics': !ascendingOrderGraphics }"
            width="20px"
            height="8px"
          >
            <path
              fill-rule="evenodd"
              fill="rgb(64, 196, 255)"
              d="M9.998,7.999 L9.998,6.999 L19.999,6.999 L19.999,7.999 L9.998,7.999 ZM9.998,4.999 L17.999,4.999 L17.999,5.999 L9.998,5.999 L9.998,4.999 ZM9.998,2.999 L16.998,2.999 L16.998,3.999 L9.998,3.999 L9.998,2.999 ZM9.998,0.999 L14.999,0.999 L14.999,1.999 L9.998,1.999 L9.998,0.999 ZM6.300,4.241 L3.954,1.878 L3.954,7.999 L2.962,7.999 L2.962,1.948 L0.687,4.241 L-0.015,3.534 L2.791,0.706 L2.791,0.706 L3.493,-0.001 L4.194,0.706 L4.194,0.706 L7.000,3.534 L6.300,4.241 Z"
            />
          </svg>
        </i>
      </div>

      <div class="icn-radio-button">
        <input
          type="radio"
          id="qq"
          name="radiogroup7"
          [checked]="isSortOptionChecked('Name')"
        />
        <label for="qq" (click)="onClickSortByOption($event, 'Name')"
          >Name</label
        ><br />
        <div class="radio-separator"></div>
        <!--<input  type="radio" id="rr" name="radiogroup7" [checked]="isSortOptionChecked('Template')">-->
        <!--<label  for="rr" (click)="onClickSortByOption($event, 'Type')">Template</label><br>-->
        <!--<div class="radio-separator"></div>-->
        <!--<input  type="radio" id="s" name="radiogroup7" [checked]="isSortOptionChecked('Type')">-->
        <!--<label  for="s" (click)="onClickSortByOption($event, 'Duration')">Type</label><br>-->
        <!--<div class="radio-separator"></div>-->
        <input
          type="radio"
          id="t"
          name="radiogroup7"
          [checked]="isSortOptionChecked('DateCreated')"
        />
        <label for="t" (click)="onClickSortByOption($event, 'DateCreated')"
          >Date Created</label
        ><br />
      </div>
    </div>

    <div class="filter-by-wrapper">
      <div class="title-wrapper">
        <span>Filter By</span>
        <span class="clear-all-filters" (click)="onClearAllFilters()"
          >Clear All</span
        >
      </div>

      <div class="filter-by-options graphics-filter">
        <div class="templates-container">
          <label class="filter-option-header">TEMPLATES:</label>
          <ul class="templates-list-container">
            <li>
              <input
                type="checkbox"
                id="allTemplates"
                class="input-hidden"
                (click)="onClickAllTemplates($event)"
                [checked]="checkAllTemplates"
              />
              <label for="allTemplates">All Templates</label>
            </li>

            <li
              *ngFor="let template of templates; let index = index"
              [ngClass]="{ 'display-none': index >= 5 && !showMoreTemplates }"
            >
              <ng-container *ngIf="index < 5 || showMoreTemplates">
                <input
                  type="checkbox"
                  [id]="index + 'template'"
                  class="input-hidden"
                  (click)="onClickTemplate($event, index)"
                  [checked]="isTemplateChecked(index)"
                />
                <label [for]="index + 'template'">{{ template.name }}</label>
              </ng-container>
            </li>
            <li *ngIf="!showMoreTemplates" class="more-tags">
              <input
                type="checkbox"
                id="moreTemplates"
                class="input-hidden"
                (click)="onToggleTemplates($event, true)"
              />
              <label for="moreTemplates"></label>
            </li>
            <li *ngIf="showMoreTemplates" class="less-tags">
              <input
                type="checkbox"
                id="lessTemplates"
                class="input-hidden"
                (click)="onToggleTemplates($event, false)"
              />
              <label for="lessTemplates"></label>
            </li>
          </ul>
        </div>

        <div class="date-created-container">
          <label class="filter-option-header">DATE CREATED:</label>
          <dateinput
            [(current)]="startDateCreatedGraphics"
            (currentChange)="changeStartDateCreated($event)"
          ></dateinput>
          <dateinput
            [(current)]="endDateCreatedGraphics"
            (currentChange)="changeEndDateCreated($event)"
          ></dateinput>
        </div>
      </div>
    </div>
  </div>
</div>
